export default __webpack_public_path__ + "static/media/U_Urubu.7912a900.svg";